import { lazy } from 'react';

export const STALE_CHUNK_RELOAD_KEY = 'atrux:stale-chunk-reload';

export const isStaleChunkError = (error) => (
  /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i
    .test(String(error?.name || '') + String(error?.message || error || ''))
);

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const recoverStaleChunk = (error, {
  storage = getSessionStorage(),
  reload = () => window.location.reload(),
} = {}) => {
  if (!isStaleChunkError(error)) return false;

  try {
    if (storage?.getItem(STALE_CHUNK_RELOAD_KEY) === '1') {
      storage.removeItem(STALE_CHUNK_RELOAD_KEY);
      return false;
    }
    storage?.setItem(STALE_CHUNK_RELOAD_KEY, '1');
  } catch {
    // Reload recovery still works when browser storage is unavailable.
  }

  reload();
  return true;
};

export const loadLazyModule = async (loader) => {
  try {
    const module = await loader();
    try {
      getSessionStorage()?.removeItem(STALE_CHUNK_RELOAD_KEY);
    } catch {
      // Loading succeeded; storage cleanup is optional.
    }
    return module;
  } catch (error) {
    if (recoverStaleChunk(error)) {
      return new Promise(() => {});
    }
    throw error;
  }
};

export const lazyScreen = (loader) => lazy(() => loadLazyModule(loader));
